// extracted by mini-css-extract-plugin
module.exports = {"gridWrapper":"page-box-grid-module--grid-wrapper--2_OZH"};